export { Text, TextProps, BaseTextProps } from './Text'
